export default function Logo({ className = "", showWordmark = true, size = "h-8" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/brand/amagic-logo.png"
        alt="AmagicTech Solutions"
        className={`${size} w-auto object-contain select-none`}
        draggable="false"
      />
      {showWordmark && (
        <span className="font-display text-base tracking-tight text-zinc-900">
          AmagicTech<span className="text-zinc-500">.</span>
        </span>
      )}
    </span>
  );
}
